module.exports = __webpack_public_path__ + "img/menuIcon16.3a991238.png";